import {component} from '../../form/Constant'
import {patientKeys} from '../../patient/PatientConstants'
import {convertKeyToLabel} from '../../table-utils/TableUtils'
import {patientOptionsList} from '../patient/Constants'

export const speedDialItemsKey = {
    note: 'note',
    reminder: 'reminder',
}

export const basicDetailInformationList = [
    {
        key: 'basicInformation',
        label: 'Basic Information',
        icon: 'pi pi-info-circle',
        children: [
            {
                key: patientKeys.title,
                label: convertKeyToLabel(patientKeys.title),
                options: patientOptionsList.title,
                component: component.dropdown,
                defaultValue: patientOptionsList.title[0].value,
            },
            {
                key: patientKeys.firstName,
                label: convertKeyToLabel(patientKeys.firstName),
                component: component.inputText,
                placeholder: '',
            },

            {
                key: patientKeys.lastName,
                label: convertKeyToLabel(patientKeys.lastName),
                component: component.inputText,
            },
            {
                key: patientKeys.email,
                label: convertKeyToLabel(patientKeys.email),
                component: component.inputText,
                keyFilter: true,
            },
            {
                key: patientKeys.gender,
                label: convertKeyToLabel(patientKeys.gender),
                options: patientOptionsList.gender,
                component: component.dropdown,
                defaultValue: patientOptionsList.gender[0].value,
            },
            {
                key: patientKeys.dob,
                label: 'Date of Birth',
                component: component.inputMask,
            },
            {
                key: patientKeys.nhsNumber,
                label: 'NHS Number',
                component: component.inputText,
            },
        ],
    },
]

export const additionalInformationList = [
    {
        key: 'additionalInformation',
        label: 'Additional Information',
        icon: 'pi pi-user-plus',
        children: [
            {
                key: patientKeys.occupation,
                label: convertKeyToLabel(patientKeys.occupation),
                component: component.inputText,
                placeholder: '',
            },
            {
                key: patientKeys.maritalStatus,
                label: convertKeyToLabel(patientKeys.maritalStatus),
                options: patientOptionsList.maritalStatus,
                component: component.dropdown,
                defaultValue: patientOptionsList.maritalStatus[0].value,
            },
            {
                key: patientKeys.religion,
                label: convertKeyToLabel(patientKeys.religion),
                options: patientOptionsList.religion,
                component: component.dropdown,
                defaultValue: patientOptionsList.religion[0].value,
            },
            {
                key: patientKeys.accommodationStatus,
                label: convertKeyToLabel(patientKeys.accommodationStatus),
                options: patientOptionsList.accommodationStatus,
                component: component.dropdown,
                defaultValue: patientOptionsList.accommodationStatus[0].value,
            },
            {
                key: patientKeys.identityWithHeldReason,
                label: convertKeyToLabel(patientKeys.identityWithHeldReason),
                options: patientOptionsList.identityWithHeldReason,
                component: component.dropdown,
                defaultValue:
                    patientOptionsList.identityWithHeldReason[0].value,
            },
            {
                key: patientKeys.diagnostic,
                label: convertKeyToLabel(patientKeys.diagnostic),
                options: patientOptionsList.diagnostic,
                component: component.dropdown,
                defaultValue: patientOptionsList.diagnostic[0].value,
            },
            {
                key: patientKeys.currentLocation,
                label: convertKeyToLabel(patientKeys.currentLocation),
                component: component.inputText,
                placeholder: '',
                col: 'col-12',
            },
        ],
    },
]

export const contactInformationList = [
    {
        key: 'contactInformation',
        label: 'Contact Information',
        icon: 'pi pi-book',
        children: [
            {
                key: patientKeys.address,
                label: convertKeyToLabel(patientKeys.address),
                component: component.address,
                col: 'col-12',
            },
        ],
    },
]

export const generalPractitionerInformationList = [
    {
        key: 'generalPractitionerInformation',
        label: 'General Practitioner Information',
        icon: 'pi pi-users',
        children: [
            {
                key: patientKeys.generalPractitioner,
                label: convertKeyToLabel(patientKeys.generalPractitioner),
                component: component.generalPractitioner,
                col: 'col-12',
            },
        ],
    },
]
